/**
 * ProductInfo类
 * 监听【购物车变化】和【产品变体切换】
 * 处理数量规则的边界修正问题
 */
if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      constructor() {
        super();

        // 记录最近浏览
        if (!!window.localStorage) this.addRecentlyViewedProduct();

// 将促销文案和卖点图标移动到 Virtual Options 前面
this.initPromoBlockReorder();

        this.quantityForm = this.querySelector(".quantity-selector"); // 数量选择器容器
        this.input = this.querySelector(".quantity-input"); // 商品数量选择器
        if (!this.quantityForm || !this.input) return;

        this.currentVariant = this.querySelector("input.product-variant-id");
        this.submitButton = this.querySelector('button[type="submit"]'); // 添加购物车按钮

        // 初始化数量边界修正
        this.setQuantityBoundries();

        // 订阅购物车变化
        // 快速产品预览无需订阅
        if (!this.dataset.originalSection) {
          // 订阅购物车更新 -> 获取最新的数量规则，并修正
          this.cartUpdateUnsubscriber = webvista.subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this),
          );
        }

        // 订阅产品变体变化
        this.variantChangeUnsubscriber = webvista.subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event.data.sectionId !== this.dataset.section) return;

            // 当变体发生变化，更新数量规则
            this.updateQuantityRules(event.data.html);

            // 更新输入框的输入边界
            this.setQuantityBoundries();
          },
        );
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      /**
       * Fetch重新获取最新的数量规则
       * 修正选择器边界规则
       */
      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;

        webvista.fetchHtml(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.sectionId}`).then(html=>{
          this.updateQuantityRules(html);
          this.setQuantityBoundries();
        }).catch((e) => {
          webvista.popToast(window["accessibilityStrings"]["unknownError"], "error");
        });
      }

      /**
       * 数量选择器边界值修正
       * 更新 input 输入框的 Min 和 Max 值
       * 当【购物车发生变化】或者【产品属性选择器变化】的时候触发更新
       */
      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity
            ? parseInt(this.input.dataset.cartQuantity)
            : 0, // 已经添加购物车数量
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1, // 单次可添加购物车的最小值
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null, // 单次结账购物车中某个产品SKU的最大值
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        // 可添加最大值 = 可购买的最大值 - 购物车中已添加的值
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);

        // 可输入最小值 <= step
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        webvista.publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      /**
       * 更新选择器数量规则
       * .quantity-input 数量输入框，更新 data-cart-quantity, data-min, data-max, step
       * .quantity-label 当前变体已经添加购物车数量
       * @param html 源 html
       */
      updateQuantityRules(html) {
        const quantityFormSource = html.querySelector(".quantity-selector");
        const selectors = [".quantity-input", ".quantity-label"];

        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormSource.querySelector(selector);

          if (!current || !updated) continue;

          if (selector === ".quantity-input") {
            const attributes = [
              "data-cart-quantity",
              "data-min",
              "data-max",
              "step",
            ];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null)
                current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      /**
       * 添加最近浏览记录
       */
      addRecentlyViewedProduct() {
        if (!this.dataset.id) return;

        const recentlyViewedData = webvista.retrieveData(RECENTLY_VIEWED_KEY) || [];
        const index = recentlyViewedData.indexOf(this.dataset.id);
        if (index !== -1) {
          recentlyViewedData.splice(index, 1); // 删除已经存在的记录
        }
        recentlyViewedData.push(this.dataset.id); // 添加新记录

        // 移出前面的元素，保持最多10个子元素
        if (recentlyViewedData.length > 10) {
          recentlyViewedData.splice(0, recentlyViewedData.length - 10);
        }

        webvista.storeData(RECENTLY_VIEWED_KEY, recentlyViewedData);
      }
/**
 * 将促销文案和 Icon with text
 * 移动到 Virtual Options 内容前面、价格后面
 */
initPromoBlockReorder() {
  const moveBlocks = () => {
    const productInfoInner =
      this.querySelector(".product-info-inner") || this;

    const bcpo = productInfoInner.querySelector("#bcpo");

    if (!bcpo || !bcpo.parentElement) {
      return false;
    }

    const promoBlock = Array.from(
      productInfoInner.querySelectorAll(
        ".product-text.product-info-block"
      )
    ).find((block) =>
      block.textContent.includes("SOMMER15")
    );

    const iconBlocks = Array.from(
      productInfoInner.querySelectorAll(
        ".product-icon-text.product-info-block"
      )
    );

    if (!promoBlock || !iconBlocks.length) {
      return false;
    }

    /*
     * 直接放进 #bcpo 所在容器，
     * 并插入到 #bcpo 前面。
     * 这样价格仍保留在促销内容上方。
     */
    const targetParent = bcpo.parentElement;

/* 添加专用样式类 */
promoBlock.classList.add("product-promo-banner");
/* 添加优惠码复制按钮 */
if (!promoBlock.querySelector(".product-promo-copy")) {
  const promoText = promoBlock.textContent || "";
  const codeMatch = promoText.match(/Code:\s*([A-Za-z0-9_-]+)/i);
  const promoCode = codeMatch ? codeMatch[1] : "SOMMER15";

  const copyButton = document.createElement("button");

  copyButton.type = "button";
  copyButton.className = "product-promo-copy";
  copyButton.setAttribute("aria-label", `Copy discount code ${promoCode}`);
  copyButton.dataset.code = promoCode;

  copyButton.innerHTML = `
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <rect
        x="8"
        y="8"
        width="11"
        height="11"
        rx="2"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      ></rect>
      <path
        d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      ></path>
    </svg>
  `;

  copyButton.addEventListener("click", async () => {
    try {
      await navigator.clipboard.writeText(promoCode);
    } catch (error) {
      const input = document.createElement("textarea");
      input.value = promoCode;
      input.style.position = "fixed";
      input.style.opacity = "0";

      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      input.remove();
    }

    copyButton.classList.add("is-copied");
    copyButton.setAttribute("aria-label", "Discount code copied");

    window.setTimeout(() => {
      copyButton.classList.remove("is-copied");
      copyButton.setAttribute(
        "aria-label",
        `Copy discount code ${promoCode}`
      );
    }, 1500);
  });

  promoBlock.appendChild(copyButton);
}
iconBlocks.forEach((block) => {
  block.classList.add("product-benefit-item");
});

/* 将促销文案放到定制选项前 */
targetParent.insertBefore(promoBlock, bcpo);

/* 创建卖点两列容器 */
let benefitsGrid = targetParent.querySelector(
  ".product-benefits-grid"
);

if (!benefitsGrid) {
  benefitsGrid = document.createElement("div");
  benefitsGrid.className = "product-benefits-grid";
  targetParent.insertBefore(benefitsGrid, bcpo);
}

iconBlocks.forEach((block) => {
  benefitsGrid.appendChild(block);
});

    return true;
  };

  if (moveBlocks()) return;

  const observer = new MutationObserver(() => {
    if (moveBlocks()) {
      observer.disconnect();
    }
  });

  observer.observe(this, {
    childList: true,
    subtree: true,
  });

  window.setTimeout(() => {
    observer.disconnect();
  }, 10000);
}
      get sectionId() {
        return this.dataset.section;
      }
    },
  );
}
